<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.5126 0.507583L15.4926 1.48755C15.8198 1.81471 16 2.24999 16 2.71294C16 3.1759 15.8198 3.61118 15.4926 3.93822L14.2922 5.13861L10.8616 1.70798L12.062 0.507583C12.7162 -0.146742 13.8577 -0.147376 14.5126 0.507583ZM1.07744 11.4906L9.88087 2.68655L13.3116 6.11731L4.50744 14.9207C4.46315 14.965 4.40769 14.9969 4.34665 15.0121L0.430094 15.988C0.402428 15.995 0.374002 15.9984 0.346209 15.9984C0.255472 15.9984 0.166765 15.9624 0.101663 15.8973C0.0156207 15.8112 -0.0190245 15.6858 0.0101637 15.568L0.98594 11.6514C1.00117 11.5911 1.03315 11.535 1.07744 11.4906Z"
    fill="white"
  />
</template>
